module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saveModal"
  }, [(_vm.saving) ? _c('div', {
    staticClass: "saveContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('saveBasket')))]), _vm._v(" "), _c('div', {
    staticClass: "saveForm"
  }, [_c('form', {
    on: {
      "submit": _vm.save
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('name')) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.save
    }
  }, [(_vm.saved) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "inline": true,
      "classes": "",
      "identifier": "save"
    }
  }), _vm._v("\n    \t\t\t\t" + _vm._s(_vm.$t('save')) + "\n    \t\t\t")], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "submit"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.updating) ? _c('div', {
    staticClass: "updateContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('saveBasket')))]), _vm._v(" "), _c('div', {
    staticClass: "message raleway"
  }, [_vm._v(" " + _vm._s(_vm.$t('updateOrnew', {
    name: _vm.currentName
  })) + " ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateSave
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "updateButtons text-center"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.updateSave
    }
  }, [(_vm.saved) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "inline": true,
      "classes": "",
      "identifier": "save"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('update')) + "\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.showSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('createNew')) + "  ")])]), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "submit"
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "updateName"
  }, [_c('input', {
    attrs: {
      "id": "updateName",
      "type": "text"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58f297a5!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Modals/Content/Save.vue
// module id = 160
// module chunks = 0